import React from 'react';
import { Box, Icon } from '@chakra-ui/react';
import { LuChevronsUpDown } from 'react-icons/lu';
import PropertyNotificationMarker from '@/components/properties/PropertyNotificationMarker';

interface PropertySelectorChevronsProps {
	hasUnreadElsewhere: boolean;
}

/** The switcher's chevrons, carrying the unread dot when a property other than the selected one needs attention. */
const PropertySelectorChevrons: React.FC<PropertySelectorChevronsProps> = ({ hasUnreadElsewhere }) => (
	<Box position="relative" display="flex" flexShrink={0}>
		<Icon as={LuChevronsUpDown} color="fg.muted" boxSize={4} />
		<PropertyNotificationMarker
			hasUnreadNotification={hasUnreadElsewhere}
			label="Another property has unread notifications"
			position="absolute"
			top="-2px"
			right="-3px"
		/>
	</Box>
);

export default PropertySelectorChevrons;
